<template>
	<div class="container">
		<h3>社保记录在哪查询？</h3>
		<br>
		<br>
		<div>1、手机支付宝查询</div>
		<br>
		<br>
		<div>打开支付宝，点击更多，选择城市服务;进去之后，点击电子社保卡，选择社保查询:进去之后，点击参保缴费明细，可以看到各个缴费记录,点击个人社保缴费记录，可以看到缴费记录详情。</div>
		<br>
		<br>
		<div>2、手机微信查询</div>
		<br>
		<br>
		<div>打开微信后关注电子社保卡微信公众号。然后将社保卡与电子社保卡进行绑定。绑定完成后，在电子社保卡会话框下方点击社保查询:进入社保服务里面，点击个人社保信息进入到业务办理页面;在个人社保信息里边点击个人社保缴费信息查询:在“险种”里面选择要查询的的保险，如:养老保险、失业保险、医疗保险、工伤保险，生育保险，然后再选择查询缴费的时间。</div>
		<br>
		<br>
		<div>3、当地社保机构查询</div>
		<br>
		<br>
		<div>可以携带本人真实有效的身份证件去所在地社保局查询。</div>
		<br>
		<br>
		<div>4、网上自主查询</div>
		<br>
		<br>
		<div>登录当地社会保障局官网，点击“个人社保信息查询”窗口，输入本人身份证和密码，即可查询本人参保信息。</div>
 
	  <button class="contain_subm"  @click="goback">返回填写信息</button>
	</div>
	
</template>

<script>
export default {
  data() {
    return {
       
    }
  },
  methods:{
	goback(){
		this.$router.go(-1)
	}
  }
}
</script>

<style lang="less" scoped>
.container{
	color: #000000;
	text-indent:2em;
	padding: 60px 30px 14px 30px;
	h3{
		text-align: center;
		font-size: @padingboxmax;
	}
	.contain_subm{
   
    margin-top: 70px;
    color:@whitee;
    background:@bluebtn;
    border: 0;
    height:@inputheight;
    border-radius: @circle;
    width: 100%;
}
	}
</style> 
 
